import utils from "../../../utils/utils.js";

export default {
  async fetchFeederTypes(context) {
    const response = await utils.utility.fetch("api/Editor/GetFeederTypes", "GET", null, null);

    context.commit("setFeederTypes", response.data);
  },
  async fetchSocialMediaProfileInfo(context, payload) {
    const response = await utils.utility.fetch(`api/Editor/GetSocialMediaProfileInfo?feedId=${payload.feedId}`, "GET", null, null);
    
    context.commit("setSocialMediaProfileInfo", response.data);
  },
  async fetchUserFeedHistory(context, payload) {
    const response = await utils.utility.fetch(`api/Editor/GetUserFeedHistory?feedId=${payload.feedId}`, "GET", null, null);
    
    context.commit("setUserFeedHistory", response.data);
  },
  async fetchOperationFeederNotes(context, payload) {
    const response = await utils.utility.fetch(`api/Editor/GetFeederNotes?feedId=${payload.feedId}`, "GET", null, null);
    
    context.commit("setOperationFeederNotes", response.data);
  },
  async putFeederGender(context, payload) {
    await utils.utility.fetch("api/Editor/UpdateFeederGender", "PUT", null, payload);

    context.commit("putFeederGender", payload);
  },
  async deleteFeederNote(_, payload) {
    const postData = { id: payload.id };

    await utils.utility.fetch("api/Editor/DeleteFeederNote", "POST", null, postData);
  },
  async postFeederNote(_, payload) {
    await utils.utility.fetch("api/Editor/createFeederNote", "POST", null, payload);
  },
  async putFeederOperationType(context, payload) {
    await utils.utility.fetch("api/Editor/ChangeFeederOperationType", "PUT", null, payload);

    context.commit("putFeederOperationType", payload);
  }
};